// extracted by mini-css-extract-plugin
module.exports = {"content":"Agreement_content__16Old","viewer":"Agreement_viewer__1FvgM","footer":"Agreement_footer__3mOVF","fadeIn":"Agreement_fadeIn__DRe6X","fadeOut":"Agreement_fadeOut__mstxD"};